// Central content + image library for Ranger Base

export const IMAGES = {
  heroRangers: "/about-hero-rangers.jpg",
  heroRoad: "https://images.unsplash.com/photo-1611564393101-b834b74a9b48?crop=entropy&cs=srgb&fm=jpg&q=85&w=2400",
  outbackWide: "https://images.unsplash.com/photo-1666079368573-182459ed245b?crop=entropy&cs=srgb&fm=jpg&q=85&w=2400",
  goldenTree: "https://images.unsplash.com/photo-1666079166566-8db002329dbd?crop=entropy&cs=srgb&fm=jpg&q=85&w=2000",
  aerialField: "https://images.unsplash.com/photo-1587882740564-e0380e0dc12a?crop=entropy&cs=srgb&fm=jpg&q=85&w=2000",
  outbackRoad2: "https://images.unsplash.com/photo-1601173073177-c0faa03462e6?crop=entropy&cs=srgb&fm=jpg&q=85&w=2000",
  roadDusk: "https://images.unsplash.com/photo-1615698068232-06d5b3174d3e?crop=entropy&cs=srgb&fm=jpg&q=85&w=2400",

  rangersMap: "https://images.unsplash.com/photo-1765378025272-68132af6e7e5?crop=entropy&cs=srgb&fm=jpg&q=85&w=2000",
  rangersDrone: "https://images.unsplash.com/photo-1781451481212-e5485f8fae45?crop=entropy&cs=srgb&fm=jpg&q=85&w=2000",
  rangersField: "https://images.unsplash.com/photo-1612844248170-ec9ed7840b91?crop=entropy&cs=srgb&fm=jpg&q=85&w=2000",
  rangersGroup: "https://images.unsplash.com/photo-1618521792989-2aaf308a79df?crop=entropy&cs=srgb&fm=jpg&q=85&w=2000",
  rangersTeam: "https://images.unsplash.com/photo-1692488272818-4255cf0d8982?crop=entropy&cs=srgb&fm=jpg&q=85&w=2000",
  rangersRiver: "https://images.unsplash.com/photo-1766040929567-bf412a2de9c8?crop=entropy&cs=srgb&fm=jpg&q=85&w=2000",

  fireHill: "https://images.unsplash.com/photo-1615092296061-e2ccfeb2f3d6?crop=entropy&cs=srgb&fm=jpg&q=85&w=2000",
  fireGrass: "https://images.unsplash.com/photo-1782790683012-3ea818d0434e?crop=entropy&cs=srgb&fm=jpg&q=85&w=2000",
  fireSmoke: "https://images.unsplash.com/photo-1635156612454-905edd65ce96?crop=entropy&cs=srgb&fm=jpg&q=85&w=2000",

  banksiaRed: "https://images.unsplash.com/photo-1774329667549-7f517fccb02a?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  banksiaOrange: "https://images.unsplash.com/photo-1713737637557-ec630e28010c?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  banksia3: "https://images.unsplash.com/photo-1677916577269-f410a7b2b8f3?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  eucalyptusLeaf: "https://images.unsplash.com/photo-1663793837069-ac844430d8c0?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  nativePlant: "https://images.unsplash.com/photo-1601537696683-9a0837578607?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",

  gumTrees: "https://images.unsplash.com/photo-1668119208053-1545bcc49e4a?crop=entropy&cs=srgb&fm=jpg&q=85&w=2000",
  eucLeaves2: "https://images.unsplash.com/photo-1524026698834-75d837ad5d15?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  silverEuc: "https://images.unsplash.com/photo-1668119207137-ed58653f992d?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",

  canopy: "https://images.unsplash.com/photo-1780748426323-9f54489d877b?crop=entropy&cs=srgb&fm=jpg&q=85&w=2000",
  surveyor: "https://images.unsplash.com/photo-1628155453612-27686cb94a25?crop=entropy&cs=srgb&fm=jpg&q=85&w=2000",
  droneForest: "https://images.unsplash.com/photo-1476933025333-7f84f8303a37?crop=entropy&cs=srgb&fm=jpg&q=85&w=2000",
  droneCoast: "https://images.unsplash.com/photo-1529928750697-1d9646312221?crop=entropy&cs=srgb&fm=jpg&q=85&w=2400",
  governanceMeeting: "/governance-meeting.jpg",
  rangerIpad: "/ranger-ipad.jpg",
  bushFoods: "https://images.unsplash.com/photo-1670622862949-7c8a1d92110b?crop=entropy&cs=srgb&fm=jpg&q=85&w=2000",

  mountainTree: "https://images.unsplash.com/photo-1676776295419-815b0fbe1c3c?crop=entropy&cs=srgb&fm=jpg&q=85&w=2000",
  creek: "https://images.unsplash.com/photo-1663793789576-f45d3bde63f1?crop=entropy&cs=srgb&fm=jpg&q=85&w=2000",
  birds: "https://images.unsplash.com/photo-1676776295520-065802f5659a?crop=entropy&cs=srgb&fm=jpg&q=85&w=2000",
  kangaroo: "https://images.unsplash.com/photo-1622644544190-d5695086b459?crop=entropy&cs=srgb&fm=jpg&q=85&w=2000",
};

export const NAV_LINKS = [
  { label: "About", path: "/about" },
  { label: "Services", path: "/services" },
  { label: "Training", path: "/training" },
  { label: "Capability", path: "/capability-framework" },
  { label: "Projects", path: "/projects" },
  { label: "Resources", path: "/resources" },
  { label: "Funding", path: "/funding-support" },
];

export const MANIFESTO = [
  "Manage Country",
  "Protect cultural heritage",
  "Monitor biodiversity",
  "Develop carbon projects",
  "Collect native seed",
  "Restore landscapes",
  "Secure funding",
  "Develop leadership",
  "Build long-term governance",
];

export const CAPABILITY_AREAS = [
  { key: "people", title: "People", icon: "Leadership", desc: "Rangers, leaders and teams who carry knowledge forward." },
  { key: "country", title: "Country", icon: "Country", desc: "Healthy land, water and biodiversity cared for over generations." },
  { key: "knowledge", title: "Knowledge", icon: "Monitoring", desc: "Indigenous knowledge working alongside ecological science." },
  { key: "governance", title: "Governance", icon: "Governance", desc: "Strong decision-making, planning and accountability." },
  { key: "enterprise", title: "Enterprise", icon: "Enterprise", desc: "Durable income streams that sustain the work." },
];

export const CAPABILITY_OUTCOMES = [
  "Healthy Country",
  "Strong Culture",
  "Employment",
  "Self-determination",
  "Resilient Organisations",
];

export const FEATURED_PROGRAMS = [
  { title: "Carbon Ready Rangers", icon: "Carbon", image: IMAGES.fireGrass, blurb: "Prepare teams and Country for savanna burning and carbon projects." },
  { title: "Biodiversity Monitoring", icon: "Biodiversity", image: IMAGES.creek, blurb: "Design and run monitoring that tracks the health of Country." },
  { title: "Species Inventory", icon: "Monitoring", image: IMAGES.birds, blurb: "Build a living record of the plants and animals on Country." },
  { title: "Seed Collection", icon: "NativeSeed", image: IMAGES.banksiaOrange, blurb: "Ethical, well-documented native seed collection on Country." },
  { title: "Seed Processing", icon: "NativeSeed", image: IMAGES.banksiaRed, blurb: "Cleaning, testing and storing seed to a professional standard." },
  { title: "Seed Bank Development", icon: "NativeSeed", image: IMAGES.nativePlant, blurb: "Establish seed banks that underpin restoration and enterprise." },
  { title: "Cultural Heritage Field Skills", icon: "Culture", image: IMAGES.gumTrees, blurb: "Record, protect and care for cultural sites on Country." },
  { title: "Leadership for Rangers", icon: "Leadership", image: IMAGES.rangersGroup, blurb: "Grow the next generation of ranger leaders and coordinators." },
  { title: "Adaptive Management", icon: "GIS", image: IMAGES.surveyor, blurb: "Plan, act, learn and adjust — management that improves over time." },
];

export const WHY_US = [
  { icon: "Leadership", title: "Building local capability", desc: "We grow the skills that stay in your organisation." },
  { icon: "Partnerships", title: "Working alongside communities", desc: "We walk together, guided by Traditional Owners." },
  { icon: "Country", title: "Practical field experience", desc: "Real work on Country, not classroom theory alone." },
  { icon: "Governance", title: "Long-term partnerships", desc: "We commit for the years it takes to build strong programs." },
  { icon: "Culture", title: "Respect for Indigenous knowledge", desc: "Cultural authority leads every step of the work." },
  { icon: "Monitoring", title: "Science informed", desc: "Sound ecological method, clearly explained." },
  { icon: "Enterprise", title: "Stronger organisations behind us", desc: "Our measure of success is what remains after we leave." },
];

export const VALUES = [
  { title: "Country", desc: "Every decision begins with the health of Country and the responsibilities that come with caring for it." },
  { title: "Culture", desc: "Cultural authority and knowledge lead the work. We follow protocols and the guidance of Traditional Owners." },
  { title: "Capability", desc: "We build the people, systems and knowledge that stay long after a project ends." },
  { title: "Partnership", desc: "We work alongside organisations, sharing skills rather than creating dependence." },
  { title: "Practical experience", desc: "We learn by doing real work on Country, together." },
  { title: "Future generations", desc: "We plan for the decades ahead, not just the next funding round." },
];

export const TIMELINE = [
  { year: "The beginning", title: "Founded on Country", desc: "Ranger Base began with a simple idea: strengthen the organisations that care for Country, rather than deliver one-off consulting." },
  { year: "Early work", title: "First ranger partnerships", desc: "We started walking alongside Traditional Owner corporations to build practical field skills and operational systems." },
  { year: "Growing", title: "Capability framework", desc: "We developed a multi-year framework that maps how ranger capability grows from foundation to long-term stewardship." },
  { year: "Today", title: "Global service delivery", desc: "We now support Indigenous ranger programs around the world, from carbon readiness to native seed enterprises." },
  { year: "The horizon", title: "Institutions that endure", desc: "Our focus remains the same — self-sustaining ranger programs that care for Country for generations." },
];

export const SERVICES = [
  {
    slug: "ranger-development",
    title: "Ranger Development",
    icon: "Leadership",
    image: IMAGES.rangersField,
    intro: "Growing confident, capable ranger teams through practical work on Country.",
    items: ["Leadership", "Mentoring", "Operational systems", "Safety", "Field skills", "Team development"],
  },
  {
    slug: "country-assessments",
    title: "Country Assessments",
    icon: "Monitoring",
    image: IMAGES.surveyor,
    intro: "Clear, science-informed assessments that describe the health of Country.",
    items: ["Carbon assessments", "Biodiversity assessments", "Vegetation surveys", "Species inventories", "Landscape monitoring", "Ecological reporting"],
  },
  {
    slug: "restoration",
    title: "Restoration",
    icon: "NativeSeed",
    image: IMAGES.nativePlant,
    intro: "From seed to landscape — restoration built on native seed systems.",
    items: ["Seed collection", "Seed processing", "Seed bank development", "Nursery planning", "Restoration planning", "Landscape recovery"],
  },
  {
    slug: "bush-foods-botanicals",
    title: "Bush Foods & Botanicals",
    icon: "NativeSeed",
    image: IMAGES.bushFoods,
    intro: "Working with culturally significant plants — from bush foods to botanicals — guided by Traditional Owners.",
    items: ["Culturally significant plants", "Bush food knowledge", "Ethical harvesting", "Botanical propagation", "Enterprise development", "Cultural protocols"],
  },
  {
    slug: "cultural-heritage",
    title: "Cultural Heritage",
    icon: "Culture",
    image: IMAGES.gumTrees,
    intro: "Caring for and protecting cultural sites, led by Traditional Owners.",
    items: ["Cultural Heritage Field Plans", "Site management", "Cultural mapping", "Monitoring", "Traditional Owner engagement", "Protocols"],
  },
  {
    slug: "strategy-governance",
    title: "Strategy & Governance",
    icon: "Governance",
    image: IMAGES.governanceMeeting,
    intro: "The planning, governance and readiness that hold strong programs together.",
    items: ["IPA readiness", "Grant readiness", "Management plans", "Operational planning", "Governance support", "Monitoring frameworks", "Business planning"],
  },
];

export const COURSES = [
  { title: "Carbon Ready Rangers", icon: "Carbon", duration: "5 days", image: IMAGES.fireGrass,
    overview: "Prepare ranger teams to plan and deliver savanna burning and carbon projects on Country.",
    outcomes: ["Understand carbon project basics", "Plan seasonal burning", "Record and report activity"],
    who: "Rangers and coordinators moving into carbon work." },
  { title: "Biodiversity Monitoring", icon: "Biodiversity", duration: "4 days", image: IMAGES.creek,
    overview: "Design and run monitoring that tracks the health of plants, animals and habitats.",
    outcomes: ["Set up monitoring sites", "Collect reliable field data", "Interpret simple trends"],
    who: "Rangers responsible for tracking the health of Country." },
  { title: "Species Inventory", icon: "Monitoring", duration: "3 days", image: IMAGES.birds,
    overview: "Build a living record of the species found on Country.",
    outcomes: ["Identify key species", "Use survey methods", "Maintain an inventory"],
    who: "Rangers building species knowledge on Country." },
  { title: "Native Seed Collection", icon: "NativeSeed", duration: "3 days", image: IMAGES.banksiaOrange,
    overview: "Ethical, well-documented native seed collection that supports restoration.",
    outcomes: ["Plan collection trips", "Collect to standard", "Record provenance"],
    who: "Rangers starting or growing seed work." },
  { title: "Seed Processing", icon: "NativeSeed", duration: "3 days", image: IMAGES.banksiaRed,
    overview: "Clean, test and store native seed to a professional standard.",
    outcomes: ["Process common species", "Run viability tests", "Store seed safely"],
    who: "Rangers managing seed after collection." },
  { title: "Seed Bank Development", icon: "NativeSeed", duration: "4 days", image: IMAGES.nativePlant,
    overview: "Establish and run a seed bank that underpins restoration and enterprise.",
    outcomes: ["Set up a seed bank", "Manage records", "Plan for enterprise"],
    who: "Organisations building seed infrastructure." },
  { title: "GIS for Rangers", icon: "GIS", duration: "4 days", image: IMAGES.rangerIpad,
    overview: "Use mapping to plan work, record activity and tell the story of Country.",
    outcomes: ["Read and make maps", "Capture field locations", "Build simple map products"],
    who: "Rangers and coordinators using spatial data." },
  { title: "Drone Mapping", icon: "GIS", duration: "3 days", image: IMAGES.droneForest,
    overview: "Fly and map Country safely to strengthen monitoring, cultural site care and coastal work. Drone mapping streamlines environmental monitoring — from detecting ghost nets and tracking feral animals to assessing weed control and erosion over time.",
    outcomes: ["Plan safe, compliant flights", "Capture aerial imagery and maps", "Apply drones to monitoring, seeding and coastal cleanup"],
    who: "Rangers introducing drones to their work." },
  { title: "Ecological Monitoring", icon: "Monitoring", duration: "5 days", image: IMAGES.canopy,
    overview: "Set up robust ecological monitoring that stands up over time.",
    outcomes: ["Design monitoring", "Standardise methods", "Report findings"],
    who: "Rangers leading long-term monitoring." },
  { title: "Adaptive Management", icon: "GIS", duration: "3 days", image: IMAGES.surveyor,
    overview: "Plan, act, learn and adjust — management that improves season by season.",
    outcomes: ["Set clear goals", "Review results", "Adjust plans"],
    who: "Coordinators and managers of ranger programs." },
  { title: "Cultural Heritage Field Skills", icon: "Culture", duration: "4 days", image: IMAGES.gumTrees,
    overview: "Record, protect and care for cultural sites, guided by Traditional Owners.",
    outcomes: ["Record sites respectfully", "Follow protocols", "Plan site care"],
    who: "Rangers working with cultural heritage." },
  { title: "Leadership for Rangers", icon: "Leadership", duration: "5 days", image: IMAGES.rangersGroup,
    overview: "Grow the next generation of ranger leaders and coordinators.",
    outcomes: ["Lead teams on Country", "Plan work", "Mentor others"],
    who: "Emerging and current ranger leaders." },
  { title: "Bush Foods & Botanicals", icon: "NativeSeed", duration: "3 days", image: IMAGES.bushFoods,
    overview: "Working with culturally significant plants — identifying, caring for and drawing on bush foods and botanicals, guided by cultural knowledge and protocols.",
    outcomes: ["Identify culturally significant plants", "Harvest ethically and safely", "Explore bush food and botanical enterprise"],
    who: "Rangers and communities working with native food and medicine plants." },
];

export const MATRIX_COLUMNS = ["Foundation", "Intermediate", "Advanced"];
export const MATRIX_ROWS = [
  { area: "Leadership", levels: ["Support the team on Country", "Coordinate crews and work plans", "Lead programs and mentor leaders"] },
  { area: "Ecology", levels: ["Recognise key species & habitats", "Run standard survey methods", "Design monitoring & interpret trends"] },
  { area: "Carbon", levels: ["Understand carbon basics", "Plan and record burning", "Manage a carbon project"] },
  { area: "Seed Systems", levels: ["Collect seed to standard", "Process, test and store seed", "Run a seed bank & enterprise"] },
  { area: "Cultural Heritage", levels: ["Follow protocols on Country", "Record and monitor sites", "Lead cultural heritage planning"] },
  { area: "Monitoring", levels: ["Collect reliable field data", "Manage monitoring sites", "Design monitoring frameworks"] },
  { area: "GIS", levels: ["Read and use maps", "Capture and manage spatial data", "Build map products & analysis"] },
  { area: "Planning", levels: ["Follow a work plan", "Develop operational plans", "Lead management planning"] },
  { area: "Governance", levels: ["Understand roles & responsibilities", "Support decision-making", "Strengthen organisational governance"] },
  { area: "Enterprise", levels: ["Understand income streams", "Support enterprise activity", "Develop and run enterprises"] },
];

export const PROJECTS = [
  {
    slug: "carbon-readiness",
    title: "Carbon Readiness Assessment",
    category: "Carbon",
    image: IMAGES.fireHill,
    location: "Northern savanna",
    challenge: "A corporation wanted to understand whether savanna burning could support a carbon project, without overcommitting the ranger team.",
    approach: "We assessed Country, mapped fire history and worked alongside rangers to plan a realistic seasonal burning program.",
    outcome: "A clear, staged pathway to carbon readiness that the organisation owns and understands.",
    impact: "A confident team with a plan that fits their capacity and their Country.",
    metrics: [{ label: "Country assessed", value: "180,000 ha" }, { label: "Rangers involved", value: "12" }, { label: "Planning horizon", value: "5 yrs" }],
  },
  {
    slug: "ipa-planning",
    title: "IPA Planning Support",
    category: "Planning",
    image: IMAGES.outbackWide,
    location: "Central Australia",
    challenge: "The corporation held deep cultural knowledge but needed help translating it into an Indigenous Protected Area plan.",
    approach: "We facilitated planning on Country, weaving Traditional Owner priorities with practical management actions.",
    outcome: "A management plan grounded in culture and ready for funding.",
    impact: "A shared plan the whole community stands behind.",
    metrics: [{ label: "On-Country workshops", value: "8" }, { label: "Priorities mapped", value: "24" }, { label: "Plan horizon", value: "10 yrs" }],
  },
  {
    slug: "native-seed-enterprise",
    title: "Native Seed Enterprise",
    category: "Restoration",
    image: IMAGES.banksiaOrange,
    location: "Southern rangelands",
    challenge: "Rangers were collecting seed, but without processing, storage or a route to income.",
    approach: "We built seed processing skills, set up a small seed bank and mapped a path to a viable enterprise.",
    outcome: "A documented seed operation with paying customers on the horizon.",
    impact: "New income that keeps rangers working on Country.",
    metrics: [{ label: "Species banked", value: "60+" }, { label: "Seed processed", value: "220 kg" }, { label: "Jobs supported", value: "6" }],
  },
  {
    slug: "biodiversity-monitoring",
    title: "Biodiversity Monitoring System",
    category: "Monitoring",
    image: IMAGES.creek,
    location: "Wet tropics",
    challenge: "Monitoring was ad hoc, making it hard to show change over time or report to funders.",
    approach: "We designed a simple, repeatable monitoring system and trained rangers to run it independently.",
    outcome: "Reliable data the organisation collects and interprets itself.",
    impact: "Stronger reporting and better decisions for Country.",
    metrics: [{ label: "Monitoring sites", value: "34" }, { label: "Species tracked", value: "90" }, { label: "Rangers trained", value: "9" }],
  },
  {
    slug: "species-inventory",
    title: "Species Inventory",
    category: "Monitoring",
    image: IMAGES.birds,
    location: "Arid interior",
    challenge: "The organisation lacked a consolidated record of species across its estate.",
    approach: "We ran surveys with rangers and built a living inventory that grows with each field trip.",
    outcome: "A shared record that supports planning, funding and cultural work.",
    impact: "Knowledge that stays and grows on Country.",
    metrics: [{ label: "Records captured", value: "1,400+" }, { label: "New for estate", value: "37" }, { label: "Field trips", value: "11" }],
  },
  {
    slug: "cultural-heritage-plan",
    title: "Cultural Heritage Field Plan",
    category: "Cultural Heritage",
    image: IMAGES.gumTrees,
    location: "Gulf Country",
    challenge: "Important sites needed care and protection, guided by the right people.",
    approach: "Led by Traditional Owners, we recorded sites respectfully and built a practical care plan.",
    outcome: "A field plan that protects sites and guides ranger work.",
    impact: "Cultural sites cared for, on cultural terms.",
    metrics: [{ label: "Sites recorded", value: "48" }, { label: "TO custodians", value: "15" }, { label: "Care actions", value: "60" }],
  },
];

export const RESOURCE_CATEGORIES = [
  "All", "Field Manuals", "Species Guides", "Videos", "Templates", "Articles", "Downloads", "Case Studies", "Grant Guides", "Toolkits",
];

export const RESOURCES = [
  { title: "Native Seed Collection Field Manual", category: "Field Manuals", type: "PDF", desc: "A practical guide to ethical, well-documented seed collection on Country." },
  { title: "Biodiversity Monitoring Handbook", category: "Field Manuals", type: "PDF", desc: "Setting up repeatable monitoring that stands up over time." },
  { title: "Common Banksia Species Guide", category: "Species Guides", type: "PDF", desc: "Identifying and caring for banksia across southern landscapes." },
  { title: "Eucalyptus Identification Guide", category: "Species Guides", type: "PDF", desc: "A field reference for recognising common eucalypts." },
  { title: "Walking Together on Country", category: "Videos", type: "Video", desc: "Rangers share how partnership and capability grow side by side." },
  { title: "Seed Processing Basics", category: "Videos", type: "Video", desc: "A short walkthrough of cleaning, testing and storing seed." },
  { title: "Monitoring Data Sheet Template", category: "Templates", type: "XLSX", desc: "A ready-to-use sheet for recording field observations." },
  { title: "Work Plan Template", category: "Templates", type: "DOCX", desc: "Plan ranger work by season with clear responsibilities." },
  { title: "What Carbon Readiness Really Means", category: "Articles", type: "Article", desc: "A plain-language look at getting ready for carbon projects." },
  { title: "Building Capability That Stays", category: "Articles", type: "Article", desc: "Why leaving stronger organisations behind matters most." },
  { title: "Seed Bank Starter Kit", category: "Downloads", type: "ZIP", desc: "Records, labels and checklists to start a small seed bank." },
  { title: "Native Seed Enterprise Case Study", category: "Case Studies", type: "PDF", desc: "How one corporation built a viable seed operation." },
  { title: "IPA Planning Case Study", category: "Case Studies", type: "PDF", desc: "Weaving cultural priorities into a fundable plan." },
  { title: "Grant Readiness Checklist", category: "Grant Guides", type: "PDF", desc: "Everything to prepare before you apply for funding." },
  { title: "Writing a Strong Funding Case", category: "Grant Guides", type: "Article", desc: "Telling your story clearly to funders and government." },
  { title: "Adaptive Management Toolkit", category: "Toolkits", type: "ZIP", desc: "Templates and prompts to plan, act, learn and adjust." },
  { title: "Cultural Heritage Field Toolkit", category: "Toolkits", type: "ZIP", desc: "Protocols and forms for recording and caring for sites." },
  { title: "Cultural Heritage Monitoring", category: "Field Manuals", type: "PDF", desc: "How to monitor and care for cultural sites over time, guided by Traditional Owners and cultural protocols." },
  { title: "Cultural Heritage Monitoring Data Sheet", category: "Templates", type: "XLSX", desc: "A structured sheet for recording the condition of cultural sites on each visit." },
  { title: "Protecting Cultural Heritage Sites on Country", category: "Videos", type: "Video", desc: "Rangers walk through a respectful approach to protecting and caring for cultural heritage sites." },
  { title: "Biodiversity Mapping (Bush Maps)", category: "Field Manuals", type: "PDF", desc: "Map biodiversity across Country with Bush Maps — recording species, habitats and health to guide care and monitoring." },
];

export const FUNDING_SUPPORT = [
  { icon: "Governance", title: "Grant applications", desc: "We help you find the right funding and write clear, compelling applications." },
  { icon: "Country", title: "IPA development", desc: "Support to plan and establish Indigenous Protected Areas on your terms." },
  { icon: "Enterprise", title: "Business cases", desc: "Practical business cases for enterprises like native seed and carbon." },
  { icon: "Partnerships", title: "Funding readiness", desc: "Getting your organisation ready so funding leads to lasting results." },
  { icon: "Leadership", title: "Capacity assessments", desc: "An honest look at where you are and what to build next." },
  { icon: "Monitoring", title: "Monitoring frameworks", desc: "Simple frameworks that make reporting straightforward." },
  { icon: "GIS", title: "Government reporting", desc: "Reporting that meets requirements without overwhelming your team." },
];

export const DRONE_APPLICATIONS = [
  { icon: "Monitoring", title: "Ghost net detection", desc: "Spot abandoned fishing nets along coastlines before they harm marine life." },
  { icon: "Biodiversity", title: "Endangered species monitoring", desc: "Survey sensitive habitats from the air without disturbing wildlife." },
  { icon: "NativeSeed", title: "Large-scale seeding", desc: "Support restoration by spreading native seed across hard-to-reach Country." },
  { icon: "Country", title: "Tracking feral animals", desc: "Locate and monitor feral animal movement across the landscape." },
  { icon: "GIS", title: "Weed & erosion assessment", desc: "Compare imagery over time to measure weed control and erosion." },
  { icon: "Culture", title: "Cultural site preservation", desc: "Record and watch over cultural sites with a minimal footprint on Country." },
];


export const ENQUIRY_TYPES = [
  "General", "Ranger Development", "Country Assessments", "Restoration",
  "Bush Foods & Botanicals", "Cultural Heritage", "Strategy & Governance", "Training", "Funding Support",
];
